import * as React from 'react';

const WebCamIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M16.221 11.153a.945.945 0 0 1 0 1.636l-5.667 3.272a.945.945 0 0 1-1.417-.818V8.699a.945.945 0 0 1 1.417-.818l5.667 3.272Z"
    />
    <path
      fill="#fff"
      d="M16.498 7.443a.945.945 0 0 1 1.336-1.335 8.292 8.292 0 0 1 0 11.726.945.945 0 0 1-1.336-1.336c2.5-2.5 2.5-6.554 0-9.055Zm-10.39 10.39a8.292 8.292 0 0 1 0-11.725.945.945 0 0 1 1.336 1.335 6.403 6.403 0 0 0 0 9.055.945.945 0 0 1-1.336 1.336Z"
    />
    <path
      fill="#fff"
      d="M18.65 5.292a.945.945 0 0 1 1.335-1.336c4.427 4.426 4.427 11.603 0 16.03a.945.945 0 1 1-1.335-1.337 9.445 9.445 0 0 0 0-13.357ZM3.955 19.985c-4.427-4.426-4.427-11.603 0-16.03a.945.945 0 1 1 1.336 1.337 9.445 9.445 0 0 0 0 13.357.945.945 0 0 1-1.336 1.336Z"
    />
  </svg>
);
export default WebCamIcon;
